import { gql } from "@apollo/client";import { useLazyQuery } from "@apollo/client/react";import React, { useState, useEffect } from 'react';
import { useForm } from '../../components/hooks/useForm';
import { Grid, Paper } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import { GetDescripcionMensaje } from '../../helpers/tools';
import logo from '../../assets/images/logo_nutrihome.png';
import fondo from '../../assets/images/Medicos.jpg';
import ZoomAni from '@mui/material/Zoom';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import toast, { Toaster } from 'react-hot-toast';

import config from '../../config';
import ErrorDialog from './../../components/ErrorDialog';
import { CustomButton } from '../../components/customButton/CustomButton';

function ResetPass() {
  const ValidacionPasswordExpReg = config.ValidacionPasswordExpReg;
  const ValidacionPasswordDescripcion = config.ValidacionPasswordDescripcion;
  const navigate = useNavigate();
  const paperStyle = { padding: 20, height: '280px', width: 280, margin: "20px auto", borderRadius: 25 };
  const btnstyle = { margin: '8px 0' };
  const [formValues, formHandle] = useForm({
    usuario: ''
  });
  const [state, setState] = useState({
    loading: false,
    error: null
  });

  const [ipClient, setIpClient] = useState('');

  // Log de errores
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  fetch('https://api.ipify.org?format=json').
  then((results) => results.json()).
  then((data) => setIpClient(data.ip)).
  catch((e) => console.log(e));

  const QReset = gql`
    query QReset($usuario: String!, $ipUsuario: String!, $pcUsuario: String!){
        resetPass(usuarioOEmail: $usuario, ipUsuario: $ipUsuario, pcUsuario: $pcUsuario) {
        valorEsperado
            {
                valido,
                msg
            },
        success,
        error    
    }          
    }`;

  const [BlanquearPass, { cargando, error: errorBlanquearPass, data: dataBlanquearPass }] = useLazyQuery(QReset);

  useEffect(() => {
		if (!dataBlanquearPass) return;
    if (dataBlanquearPass.resetPass.success) {
      if (dataBlanquearPass.resetPass.valorEsperado.valido) {
        toast.success(dataBlanquearPass.resetPass.valorEsperado.msg);
        navigate("/");
      } else
      toast.error(dataBlanquearPass.resetPass.error);
    } else
    {
      let descripcionError = GetDescripcionMensaje(dataBlanquearPass.resetPass.error);
      if (isNaN(descripcionError)) {
        let mensaje = `${dataBlanquearPass.resetPass.error} - ${descripcionError}`;
        toast.error(mensaje);
      } else
      {
        setMensajeError(dataBlanquearPass.resetPass.error);
      }
    }
	}, [dataBlanquearPass]);

	useEffect(() => {
		if (!errorBlanquearPass) return;
    setMensajeError("ERRORDB");
    setState((prevState) => {
      return { ...prevState, error: 'Usuario incorrecto' };
    });
    return false;
	}, [errorBlanquearPass]);  

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleClick();
    }
  };

  const isFormValid = () => {
    if (formValues.usuario.length === 0) {
      toast.error("El Usuario o Email es obligatorio");
      return false;
    } else
    {
      setState((prevState) => {
        return { ...prevState, error: null };
      });
      return true;
    }
  };
  const handleClick = () => {
    if (isFormValid()) {
      BlanquearPass({ variables: { usuario: formValues.usuario, ipUsuario: ipClient, pcUsuario: '' } });
    }
  };
  return (
    <Box
      display="flex"
      alignItems="center"
      style={{
        minHeight: "100vh", backgroundColor: "rgb(210, 210, 210,0.3)",
        backgroundImage: `url(${fondo})`, backgroundRepeat: "no-repeat", backgroundBlendMode: "lighten", backgroundSize: "cover"
      }}
      zIndex="1">
      
            <ZoomAni in>
                <Paper elevation={10} style={paperStyle}>
                    <Grid align='center'>
                        <h3 style={{ color: "rgb(0,114,186)" }}>Recuperar Contraseña</h3>
                        <img src={logo} width='70%'></img>
                    </Grid>
                    <br></br>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-user">Usuario o Email</InputLabel>
                        <OutlinedInput
              id="outlined-adornment-user"
              name='usuario'
              label='Usuario o Email'
              inputProps={{ style: { textAlign: 'center' } }}
              placeholder='Usuario o Email'
              value={formValues.usuario}
              onChange={formHandle}
              onKeyDown={handleKeyDown}
              fullWidth required />
            
                    </FormControl>
                    <CustomButton
            loading={state.loading}
            loadingIndicator="Enviando Mail..."
            style={btnstyle}
            variant="contained"
            onClick={handleClick}
            fullWidth>
                        Recuperar
                    </CustomButton>
                    <hr></hr>
                    <Box style={{ marginTop: "20px", textAlign: "right" }} fullWidth>
                        <Link style={{ color: "rgb(0,114,186)" }} to="/">
                            Volver
                        </Link>

                    </Box>
                </Paper>
            </ZoomAni>
            
            <ErrorDialog
        id="dlg-error-resetPass"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      
        </Box>);

}

export default ResetPass;